import { render, staticRenderFns } from "./ModuleRecord.vue?vue&type=template&id=48e7b414&scoped=true&lang=pug&"
import script from "./ModuleRecord.vue?vue&type=script&lang=js&"
export * from "./ModuleRecord.vue?vue&type=script&lang=js&"
import style0 from "./ModuleRecord.vue?vue&type=style&index=0&id=48e7b414&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48e7b414",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VIcon,VList,VMenu})
